// extracted by mini-css-extract-plugin
module.exports = {"tokens-header":"page_tokens-header__iS5Ze","topGainersLabel":"page_topGainersLabel__QHegy","topGainersSwiperWrap":"page_topGainersSwiperWrap__PIQYu"};